// extracted by mini-css-extract-plugin
module.exports = {"sub-text":"UsersGroupsSelect-module__sub-text__5Dl8R","invisible":"UsersGroupsSelect-module__invisible__GSAEG"};